import { Wrapper, StyledPicture } from "./styled";

export const NoResults = ({ query }) => (
  <Wrapper>
    <StyledPicture />
  </Wrapper>
);
